export default __webpack_public_path__ + "static/media/RobustaEspresso.8a343894.png";